import React, { FC } from 'react'
import { HighlightResult } from 'react-instantsearch-core'
import { connectSearchBox, connectStats } from 'react-instantsearch-dom'

import { SearchBar } from './SearchBar'

import { Food, Recipe } from 'Models'
import { Formatter } from 'Utils'

type SearchBoxProps = {
  currentRefinement: string
  isSearchStalled: boolean
  refine: (text: string) => void
  onChange?: (text: string) => void
  labelText?: string
}

const SearchBox: FC<SearchBoxProps> = ({ refine, onChange, labelText }) => (
  <SearchBar
    onChangeText={(text) => {
      refine(text)
      onChange && onChange(text)
    }}
    labelText={labelText}
  />
)

type StatsProps = { nbHits: number; hitName?: { singular: string; plural: string } }

export const Stats: FC<StatsProps> = ({ nbHits, hitName = { singular: 'Eintrag', plural: 'Einträge' } }) => (
  <span>
    {Formatter.formatNumber(nbHits)} {nbHits === 1 ? hitName?.singular : hitName?.plural} gefunden
  </span>
)

export const CustomStats = connectStats(Stats)

export const CustomSearchBox = connectSearchBox(SearchBox)

// type HighlightResult

export type UserEatable = Food | Recipe

export type UserEatableSearchHit<E extends UserEatable> = E & {
  _highlightResult: HighlightResult<E>
}
